module.exports = __webpack_public_path__ + "static/img/M-6.ba0f92f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgaofu/M-6.png
// module id = pWkc
// module chunks = 0